module.exports = __webpack_public_path__ + "img/Flag_of_the_Cayman_Islands.884c0ef1.svg";